import { useMemo } from 'react';
import { getStrings } from '@veylme/shared';
import { useLocale } from '../i18n/LocaleContext.js';
export function useT() {
  const locale = useLocale();
  return useMemo(() => getStrings(locale), [locale]);
}
